import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

function initials(title: string) {
  return String(title || '?').trim().slice(0, 1).toUpperCase() || '?'
}

export function InstagramSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const photo = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const photoSrc = photo?.src || photo?.thumbSrc
  return (
    <>
      <div className={`md-subs-instagram-row m-2 inline-flex w-80 flex-col overflow-hidden rounded-lg border border-[#dbdbdb] bg-white font-[-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,Helvetica,Arial,sans-serif] text-sm text-[#262626] transition hover:shadow-[0_4px_12px_rgba(0,0,0,0.15)]${display.isChecked ? ' md-subs-instagram-row--checked border-[#0095f6]' : ''}`}>
        <div className="md-subs-instagram-head flex items-center gap-3 border-b border-[#efefef] px-3 py-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] text-sm font-bold text-white">{initials(display.identity.author || display.title)}</div>
          <div className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap font-semibold [&_.md-sub-title-link]:text-[#262626]">{controls.content.title}</div>
          {controls.actions.favorite}
        </div>
        {photoSrc ? <img className="aspect-square w-full bg-[#efefef] object-cover" src={photoSrc} alt={photo.title || photo.filename || display.title} /> : null}
        <div className="md-subs-instagram-body min-h-[160px] p-3 leading-[1.35] [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-[#262626]">{controls.content.text}</div>
        <div className="md-subs-instagram-actions flex items-center gap-3 px-3 pb-2">
          {controls.actions.check}
          {controls.actions.quickReply}
          {controls.links.answers}
          {controls.links.submsges}
        </div>
        <div className="px-3 pb-3 text-xs text-[#8e8e8e]">{controls.content.time}</div>
      </div>
      <div className="md-subs-instagram-children ml-4">{slots.allChildren}</div>
    </>
  )
}
